module.exports = __webpack_public_path__ + "static/media/logout-exit-signout-door-out-common-icon.dd083ff1.svg";